export default "__VITE_ASSET__77378327__"